// extracted by mini-css-extract-plugin
module.exports = {"headerBox":"datagridheader_headerBox__2toXr","filterBtn":"datagridheader_filterBtn__2OiI7","activeFilterIndicator":"datagridheader_activeFilterIndicator__2ge0B"};